module.exports = __webpack_public_path__ + "media/src/public/fonts/Gals-Regular-ecc8b40ae40ba12d088cb8f95029206c.woff";